module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-form-search-cities"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "space-40"
  }), _vm._v(" "), _c('loading'), _vm._v(" "), _c('div', {
    staticClass: "space-40"
  })], 1) : _c('div', [(_vm.cities.length > 0) ? _c('div', {
    staticClass: "list-group margin-bottom-0"
  }, _vm._l((_vm.cities), function(c) {
    return _c('a', {
      staticClass: "list-group-item",
      class: {
        'active': c.id == _vm.city.id
      },
      staticStyle: {
        "border-radius": "0"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.setCity(c)
        }
      }
    }, [_vm._v(_vm._s(c.name) + " - " + _vm._s(c.state.initials))])
  }), 0) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce10d18e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormSearchCities.vue
// module id = 324
// module chunks = 18